export const OVERLAY_INSET = 12;

export function needsOverlaySheet(viewportHeight: number, anchorBottom: number, contentHeight: number): boolean {
  return viewportHeight - anchorBottom - OVERLAY_INSET - 6 < Math.max(260, contentHeight);
}

/** Keep the entire panel visible, not just its drag handle. */
export function clampOverlayDelta(rect: { left: number; top: number; width: number; height: number }, dx: number, dy: number, width: number, height: number) {
  const left = Math.max(OVERLAY_INSET, Math.min(width - rect.width - OVERLAY_INSET, rect.left + dx));
  const top = Math.max(OVERLAY_INSET, Math.min(height - rect.height - OVERLAY_INSET, rect.top + dy));
  return { x: left - rect.left, y: top - rect.top };
}
